
define('text!templates/widgets/dataGridCells/hyperlinkButtonCell.html',[],function () { return '<a data-bind="text: label, click: click" href="#"></a>';});

